import { render, staticRenderFns } from "./ProducedProductForm.vue?vue&type=template&id=2561aa08&scoped=true&"
import script from "./ProducedProductForm.vue?vue&type=script&lang=ts&"
export * from "./ProducedProductForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProducedProductForm.vue?vue&type=style&index=0&id=2561aa08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2561aa08",
  null
  
)

export default component.exports